"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextHeader = void 0;
// eslint-disable-next-line no-shadow
var ContextHeader;
(function (ContextHeader) {
    ContextHeader["TOOL_NAME"] = "tool-name";
    ContextHeader["PROJECT_ID"] = "project-id";
    ContextHeader["PROJECT_NAME"] = "project-name";
    ContextHeader["PROJECT_AREA"] = "project-area";
    ContextHeader["PROJECT_VENDOR"] = "project-vendor";
    ContextHeader["PROJECT_HOSTNAME"] = "project-hostname";
    ContextHeader["TRANSACTION_ID"] = "transaction-id";
    ContextHeader["SESSION_ID"] = "session-id";
})(ContextHeader = exports.ContextHeader || (exports.ContextHeader = {}));
